import type { FaireProductEntity } from "../../entity_types/product";

export const p_2cjb5xygrt: FaireProductEntity = {
  token: "p_2cjb5xygrt",
  type: "product",
  name: "Thank You So Matcha Tea Card",
  brandToken: "b_96blrd2y",
  brandName: "Tender Loving Empire",
  imageUrl:
    "https://cdn.faire.com/fastly/76b26cdcfd94ec25aea4ffd303b1a754c26e69ba99be71816e019829168c708c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/845a66872bf6b05647f09debe34e3b4c1f01e4d9d21a93914778eb60d114b50a.jpeg",
  ],
  priceDollars: 3.25,
  description:
    "This card is blank inside. Comes in a cello sleeve with a white envelope.\n\nSize A2 Flat - 4.25 x 5.5 inches. SKU printed on back.\n\nDesigned and printed locally in Portland, Oregon.\n\nThank You Card, Thanks Card, Thank You So Much, Greeting Card, Matcha Tea Latte Coffee Mug Mugs Happy Cute Funny Pun",
  tags: [],
  msrpDollars: 6.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:13.309Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
